<template>
	<b-card no-body class="p-3" v-loading="is_loading">
		<div class="card-table-simple">
			<b-table-simple responsive bordered class="mb-0">
				<b-tbody>
					<b-tr>
						<b-th class="w-50">Loan Type</b-th>
						<b-td>
							<b-form-select v-model="formData.loan_type_id" @change="calculate" :disabled="isViewOnly">
								<b-form-select-option :value="''">Please select loan type</b-form-select-option>
								<b-form-select-option v-for="item in this.filteredLoanTypes" :key="item.id" :label="item.name"
									:value="item.id">{{
										item.name }}</b-form-select-option>
							</b-form-select>
						</b-td>
					</b-tr>
				</b-tbody>
			</b-table-simple>
		</div>
	</b-card>
</template>
<script>
import { gEventBus } from '@/assets/js/EventBus/gEventBus.js'
import { mapState, mapActions } from 'pinia';
import { useCustomerStore } from '@/stores/customerStore';
import { useCommonStore } from '@/stores/commonStore';

export default {
	props: ['is-view-only','loan_type_id'],
	data() {
		return {
			formData:{
				loan_type_id: ''
			}
		}
	},
	created() {
	},
	beforeDestroy() {
		this.clearComponent()
	},
	beforeUnmount(){
		this.clearComponent()
	},
	computed: {
		...mapState(useCommonStore, ['loanTypes']),
		filteredLoanTypes() {
			return this.loanTypes.filter(item => { return item['code'] !== 'FEL' && item['code'] !== 'ML' })
		},
		is_loading() {
			return _gHlp.isLoading('fetch_loan_type') || _gHlp.isLoading('fetch_loan_ec')
		}
	},
	watch: {
		loanTypes: {
			handler(newVal) {
				if (!_gHlp.isEmpty(newVal)) {
					this.calculate()
				}
			},
			immediate: true
		},
		loan_type_id: {
			handler(newVal,oldVal) {
				if (!_gHlp.isEmpty(newVal)) {
					if(newVal != oldVal){
						this.formData.loan_type_id = newVal
						this.calculate();
					}
				}
			},
			immediate: true
		}
	},
	methods: {
		...mapActions(useCustomerStore, ['setFormLoanEc','updateLoanEC']),
		clearComponent(){
			this.formData = {
				loan_type_id: ''
			}
		},
		calculate() {
			if(!_gHlp.isEmpty(this.loanTypes) && !_gHlp.isEmpty(this.formData.loan_type_id)){
				// console.log('SET LOAN TYPE')
				if(this.formData.loan_type_id != this.loan_type_id){
					_gHlp.setLoading('fetch_loan_ec')
					let selectedLoanType = this.loanTypes.find(itm => itm.id == this.formData.loan_type_id);
					let params = {
						loan_type_id:this.formData.loan_type_id,
						loan_tenure_period: selectedLoanType.loan_tenure_period,
						// loan_tenure: selectedLoanType.loan_tenure,
						// loan_tenure_year: (selectedLoanType.loan_tenure_period == 'Months') ? selectedLoanType.loan_tenure /12 : selectedLoanType.loan_tenure,
						loan_eligible_period: '',
						// installment_amount: selectedLoanType.normal_installment,
						moratorium_tenure: _gHlp.getValue(selectedLoanType,'moratorium_tenure',0),
						moratorium_eligible_rate: _gHlp.getValue(selectedLoanType,'moratorium_installment_percentage',0),
						moratorium_start_period: 1,
						stamping_fee_prc: parseFloat(_gHlp.getValue(selectedLoanType,'stamp_duty_rate',0)),
						vet_fac_prc: parseFloat(_gHlp.getValue(selectedLoanType,'vet_fac_rate',0)),
						vet_fac_sst: parseFloat(_gHlp.getValue(selectedLoanType,'sst_rate',8)),
						legal_base_amt: parseFloat(_gHlp.getValue(selectedLoanType,'legal_fees',0)),
						legal_sst_prc: parseFloat(_gHlp.getValue(selectedLoanType,'sst_rate',8)),
					}

					this.updateLoanEC(params).then(resp=>{
						this.$emit('change',this.formData.loan_type_id);
						_gHlp.removeLoading('fetch_loan_ec')
					}).catch(err=>{
						_gHlp.removeLoading('fetch_loan_ec')
					})
				}else{
					this.$emit('change',this.formData.loan_type_id);
				}
			}
		},
		
	}
}
</script>